let CameraService = /** @class */ (function () {
    function CameraService($q, $mdPanel, $translationService, $ionicPopup, $timeout) {
        this.$q = $q;
        this.$mdPanel = $mdPanel;
        this.$translationService = $translationService;
        this.$ionicPopup = $ionicPopup;
        this.$timeout = $timeout;
    }

    CameraService.prototype = {
        showPhotosOrDocumentsPanel($event, options) {
            return this.$q((resolve) => {
                let position = this.getPosition($event.currentTarget, 3, 58);
                let config = {
                    controller: 'PhotoDocumentsController',
                    controllerAs: 'vm',
                    templateUrl: 'js/shared/camera/photo_documents/photo_documents.modal.html',
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    locals: {
                        dialogData: {
                            onClose: function (data) {
                                resolve(data);
                            },
                            onStart: function () {
                                if (options.onStart) {
                                    options.onStart();
                                }
                            },
                            acceptOnlyPicture: options.acceptOnlyPicture
                        }

                    },
                    position: position,
                    zIndex: 200
                };
                this.panelRef = this.$mdPanel.create(config);
                this.$timeout(100).then(()=>{
                    this.panelRef.open();
                })

            });
        },
        showCameraPreviewModal() {
            let _this = this;
            return this.$q(function (resolve) {
                let config = {
                    controller: 'CameraPreviewController',
                    controllerAs: 'vm',
                    templateUrl: 'js/shared/camera/camera_preview/camera_preview.view.html',
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    panelClass: 'full-screen-panel',
                    locals: {
                        onClose: function (data) {
                            resolve(data);
                        }
                    }
                };
                _this.panelRef = _this.$mdPanel.create(config);
                _this.panelRef.open().then((panelRef)=>{
                    // init component
                    /** @type {MdPanelRef} panelRef */
                    panelRef._config.scope.vm.init();
                })
            });
        },
        /**
         *
         * @param element{Element}
         * @param number{number}
         * @param itemHeight{number}
         * @return {MdPanelPosition}
         */
        getPosition(element, number, itemHeight){
            let offset = $(element).offset();
            let bottom = $(window).height() -  offset.top;
            let right = $(window).width() -  offset.left;
            let position = this.$mdPanel.newPanelPosition().absolute();


            // Calc left/right
            if(right >= 200){
                position = position.left(offset.left);
            } else {
                position =position.right(10);
            }

            // Calc top, otherwise center
            if(offset.top>=number*itemHeight){
                position =position.bottom(bottom);
            } else{
                position =position.centerVertically();
            }
            return position;
        },

        /**
         * Checking camera permission for Camera
         * @return {Promise<'GRANTED' | 'DENIED' | 'DENIED_ONCE' | 'DENIED_ALWAYS'>}
         * @private
         */
        checkCamera() {
            return this.$q((resolve, reject) => {
                // Reference to Cordova's diagnostic plugin for detecting and managing device settings.
                var diagnostic = cordova.plugins.diagnostic;

                // whether the Request Camera Authorization Dialog has been shown to the user or not. (default: false).
                var isShownRequestAuthorizationDialog = false;

                // A function that requests camera permissions.
                function requestCameraAuthorization() {
                    var startTime = new Date().getTime();
                    diagnostic.requestCameraAuthorization(function (status) {
                        if (new Date().getTime() - startTime > 500) {
                            isShownRequestAuthorizationDialog = true;
                        }
                        if (status === diagnostic.permissionStatus.DENIED_ONCE) {
                            resolve('DENIED_ONCE');
                        } else {
                            checkPermission(status);
                        }
                    }, function () {
                        reject();
                    }, false);
                }

                // A function that checks the camera permissions.
                function checkPermission(permissionStatus) {
                    console.log('checkCameraPermission', permissionStatus);
                    switch (permissionStatus) {
                        // If the camera permission status is  'NOT_REQUESTED', 'DENIED_ONCE'
                        // request the user for camera authorisation
                        case diagnostic.permissionStatus.NOT_REQUESTED:
                        case diagnostic.permissionStatus.DENIED_ONCE:
                            requestCameraAuthorization();
                            break;
                        // Case where the permission is GRANTED
                        case diagnostic.permissionStatus.GRANTED:
                            resolve('GRANTED');
                            break;
                        default:
                            //DENIED: Show explain
                            resolve(isShownRequestAuthorizationDialog ? 'DENIED_ALWAYS' : 'DENIED');
                            break;
                    }
                }

                // Call function to initiate permission check
                diagnostic.getCameraAuthorizationStatus(function (permissionStatus) {
                    // If running on Android 11+(>=11) and status is DENIED_ALWAYS, (Ask every time)
                    if (device.platform === 'Android' && parseFloat(device.sdkVersion) >= 30 && permissionStatus === diagnostic.permissionStatus.DENIED_ALWAYS) {
                        permissionStatus = diagnostic.permissionStatus.DENIED_ONCE;
                    }
                    checkPermission(permissionStatus);
                }, function () {
                    reject();
                }, false);
            })

        },
        /**
         * Check permission, if camera GRANTED callback
         * @returns {Promise<void>}
         * @public
         */
        checkCameraPermission() {
            return this.$q((resolve, reject) => {
                this.checkCamera().then((status) => {
                    switch (status) {
                        case "GRANTED":
                            resolve();
                            break;
                        case "DENIED":
                            reject();
                            this.$ionicPopup.confirm({
                                template: this.$translationService.formatTranslation('EnablePermission', this.$translationService.getTranslation('Camera')),
                                cssClass: 'reserved-confirm',
                                buttons: [
                                    {
                                        text: this.$translationService.getTranslation('AppSettings'),
                                        type: 'button-positive',
                                        onTap: function () {
                                            // Open application detail
                                            cordova.plugins.diagnostic.switchToSettings(() => {
                                            }, () => {
                                            });
                                        }
                                    },
                                    {
                                        text: this.$translationService.getTranslation('OK')
                                    }
                                ]
                            });
                            break;
                        default:
                            reject();
                    }
                },()=>{
                    reject();
                })
            })
        },

        closeCamera() {
            try {
                // Close camera
                if (window['CameraPreview']) {
                    window['CameraPreview'].stopCamera();
                }

                // Close panel
                if (this.panelRef) {
                    this.panelRef.close();
                    this.panelRef = null;
                }
            } catch (e) {

            }
        }

    }

    CameraService.$inject = ['$q', '$mdPanel', '$translationService', '$ionicPopup','$timeout'];
    return CameraService;
}());
angular.module('shared').service('CameraService', CameraService);
